import DateFormat from "../common/dateFormat/DateFormat";

const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	filtro: {
		data_inicial: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAnterior(10)),
		data_final: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual()),
	},
	lista: []
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case 'CONFERENCIA_CHECKLIST_MODO_TELA':
			return {
				...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'CONFERENCIA_CHECKLIST_FILTRO':
			return { ...state, filtro: action.payload };

		case 'CONFERENCIA_CHECKLIST_LISTADO':
			return { ...state, lista: action.payload.data };


		case 'CONFERENCIA_CHECKLIST_SET_AGUARDANDO':
			return {
				...state,
				aguardando: action.payload
			};

		default:
			return state;
	}
}
